const LINEAR_UPLOAD_HOST = "uploads.linear.app"

// Linear upload URLs are auth-gated, so anything rendering them outside a Linear
// session needs a public mirror first.
export const isLinearUploadUrl = (url: string): boolean => {
	try {
		return new URL(url).hostname === LINEAR_UPLOAD_HOST
	} catch {
		return false
	}
}
